module.exports = __webpack_public_path__ + "img/bg_login.41536c09.jpg";